var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHelpCircle = function SvgHelpCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 2a7 7 0 1 0 0 14A7 7 0 0 0 9 2m0 13A6 6 0 1 1 9 3a6 6 0 0 1 0 12"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 12.77a.538.538 0 1 0 0-1.078.538.538 0 0 0 0 1.077Zm.386-7.54h-.77c-.303 0-.603.054-.884.16-.28.105-.535.26-.749.456a2.1 2.1 0 0 0-.5.684c-.116.256-.175.53-.174.808v.234h1.025v-.234c0-.311.135-.609.376-.828.24-.22.566-.343.906-.343h.77c.34 0 .666.123.906.343s.376.517.376.828-.135.608-.376.827c-.24.22-.566.343-.906.343H8.36v2.107h1.026v-1.17c.612 0 1.199-.222 1.631-.618.433-.395.676-.93.676-1.49a2.02 2.02 0 0 0-.676-1.49 2.42 2.42 0 0 0-1.631-.617"
  })));
};
export default SvgHelpCircle;